import React, { useEffect, useState } from 'react';
import { Modal } from 'antd';
import cn from 'classnames';
import styles from './index.module.less'
import ReviewDetail from '../ReviewDetail';
import type { IReview } from 'mod/review/interface';

type IProps = {
    open: boolean;
    onClose?: () => void;
    onCloseModal?: () => void;
    review?: IReview;
}

const ReviewDetailModal: React.FC<IProps> = (props) => {
    const { open, onClose, onCloseModal, review } = props;

    return(
        <Modal
            className={cn(styles.modal)}
            destroyOnClose={true}
            width={720}
            open={open}
            onCancel={onClose||onCloseModal}
            footer={false}
            centered
        >
            <ReviewDetail review={review}/>
        </Modal>
    );
};

export default ReviewDetailModal